<template>
  <div>
    <div class="banner">
      <section class="hero-section">
        <div class="section-inner hero-inner">
          <div class="hero-left">
            <h1 class="hero-title aw-anim">云稼科技，赋能企业数字化转型</h1>
            <p class="hero-subtitle aw-anim">
              专注APP开发、小程序、管理系统、网站定制，从需求分析到上线运维一站式软件技术服务
            </p>
            <el-button type="primary" class="hero-btn aw-anim" @click="onConsult">
              立即咨询 <i class="el-icon-right"></i>
            </el-button>
          </div>
        </div>
      </section>
    </div>
    <!-- 数据统计 -->
    <section class="stats-section">
      <div class="section-inner stats-inner">
        <div class="stat-card" v-for="(item, index) in stats" :key="index">
          <div class="stat-icon">
            <img :src="item.icon" alt="" />
          </div>
          <div class="stat-info">
            <div class="stat-num">{{ item.num }}</div>
            <div class="stat-label">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心能力中心 -->
    <section class="capability-section">
      <div class="section-inner capability-inner">
        <div class="section-header">
          <h2 class="section-title aw-anim">核心能力中心</h2>
          <p class="section-subtitle aw-anim">
            AI智能、数据智能与产业运营三大中心构建平台智能内核
          </p>
        </div>
        <div class="capability-grid">
          <div class="capability-card aw-anim" v-for="(item, index) in capabilities" :key="index">
            <div class="capability-img">
              <img :src="item.img" :alt="item.title" />
            </div>
            <!-- 默认视图 -->
            <div class="capability-normal">
              <!-- <div class="capability-content"></div> -->
              <h3 class="capability-title">{{ item.title }}</h3>
              <p class="capability-detail-desc">{{ item.desc }}</p>
              <ul class="capability-list">
                <li v-for="(li, liIndex) in item.list" :key="liIndex">
                  <img class="check-icon" :src="require(`@/assets/newindex/agree.png`)" alt="" />
                  <span>{{ li }}</span>
                </li>
              </ul>
              <div class="capability-detail-cards">
                <div class="capability-detail-card" v-for="(card, cIndex) in item.detailCards" :key="cIndex">
                  <h4 class="detail-card-title">{{ card.title }}</h4>
                  <p class="detail-card-desc">{{ card.desc }}</p>
                </div>
              </div>
            </div>

            <!-- hover 详情视图 -->
            <!-- <div
              class="capability-detail"
              v-show="hoverCapabilityIndex === index"
            >
              <div class="capability-detail-header">
                <div class="capability-detail-info">
                  <h3 class="capability-detail-title">{{ item.title }}</h3>
                  <p class="capability-detail-desc">{{ item.desc }}</p>
                </div>
                <div class="capability-detail-img">
                  <img :src="item.img" :alt="item.title" />
                </div>
              </div>
              <div class="capability-detail-cards">
                <div
                  class="capability-detail-card"
                  v-for="(card, cIndex) in item.detailCards"
                  :key="cIndex"
                >
                  <h4 class="detail-card-title">{{ card.title }}</h4>
                  <p class="detail-card-desc">{{ card.desc }}</p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <!-- 行业应用生态 -->
    <section class="industry-section">
      <div class="section-inner industry-inner">
        <div class="section-header">
          <h2 class="section-title aw-anim">行业应用生态</h2>
          <p class="section-subtitle aw-anim">
            九大行业应用覆盖农业生产、经营、服务、交易全场景
          </p>
        </div>

        <!-- tab 导航 -->
        <div class="industry-tabs">
          <div class="industry-tab" :class="{ active: industryActiveId === index }"
            v-for="(item, index) in industryTabs" :key="index" @click="switchIndustry(index)">
            <img class="tab-icon" :src="item.icon" alt="" />
            <span class="tab-text">{{ item.title }}</span>
          </div>
        </div>
      </div>
      <div class="industry-content-container" style="background: #f5f8fe">
        <!-- tab 内容 -->
        <div class="section-inner industry-content">
          <div class="industry-phones">
            <img v-if="industryContents[industryActiveId].type == 'app'" class="phone"
              :src="industryContents[industryActiveId].phone1" alt="" />
            <img v-else class="pc-phone" :src="industryContents[industryActiveId].phone1" alt="" />

          </div>
          <div class="industry-desc">
            <!-- <h3 class="desc-title">
              {{ industryContents[industryActiveId].title }}
            </h3> -->
            <p class="desc-text">
              {{ industryContents[industryActiveId].desc }}
            </p>
            <el-button type="primary" class="desc-btn" @click="onViewScheme">
              查看更多 <i class="el-icon-right"></i>
            </el-button>
          </div>
        </div>
      </div>
    </section>

    <!-- 总体架构设计 -->
    <section class="architecture-section">
      <div class="section-inner architecture-inner">
        <div class="section-header">
          <h2 class="section-title aw-anim">总体架构设计</h2>
          <p class="section-subtitle aw-anim">
            一个平台、一个底座、三大中心、一个交易服务层、N个行业应用
          </p>
        </div>

        <div class="architecture-cards">
          <div class="architecture-card aw-anim" v-for="(item, index) in architectureCards" :key="index">
            <img :src="item.bg" class="arch-card-bg" alt="" />
            <img class="arch-card-icon" :src="item.icon" alt="" />
            <h3 class="arch-card-title">{{ item.title }}</h3>
            <p class="arch-card-desc">{{ item.desc }}</p>
          </div>
        </div>

        <div class="architecture-tags">
          <div class="arch-tag-col aw-anim" v-for="(col, cIndex) in architectureTags" :key="cIndex">
            <div class="arch-tag-group" v-for="(group, gIndex) in col.groups" :key="gIndex">
              <h4 class="arch-tag-title">{{ group.title }}</h4>
              <div class="arch-tag-list">
                <span class="arch-tag-item" v-for="(tag, tIndex) in group.tags" :key="tIndex">{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 业务闭环与设计原则 -->
    <section class="loop-section">
      <div class="section-inner loop-inner">
        <div class="section-header">
          <h2 class="section-title aw-anim">业务闭环与设计原则</h2>
          <p class="section-subtitle aw-anim">
            从生产到交易的产业闭环，从数据到智能的能力流转
          </p>
        </div>

        <div class="loop-content">
          <div class="loop-chart">
            <img src="@/assets/newindex/chart1.png" alt="业务闭环" />
          </div>
          <div class="loop-cards">
            <div class="loop-card aw-anim" v-for="(item, index) in loopCards" :key="index">
              <h3 class="loop-card-title">{{ item.title }}</h3>
              <p class="loop-card-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>

        <div class="loop-process">
          <div class="process-step" v-for="(item, index) in processSteps" :key="index">
            <div class="process-icon-container">
              <img class="process-icon" :src="item.icon" alt="" />
            </div>

            <span class="process-title">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 关于我们 -->
    <section class="about-section">
      <div class="section-inner about-inner">
        <div class="about-header">
          <h2 class="section-title aw-anim">关于我们</h2>
        </div>
        <div class="about-content">
          <div class="about-info">
            <h3 class="about-company aw-anim">{{ aboutInfo.company }}</h3>
            <p class="about-desc aw-anim">{{ aboutInfo.desc }}</p>
            <el-button type="primary" class="about-btn aw-anim" @click="onViewMore">
              查看更多 <i class="el-icon-right"></i>
            </el-button>
          </div>
          <div class="about-img">
            <img :src="aboutInfo.img" alt="" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "NewIndex",
  data() {
    return {
      stats: [
        {
          num: "3",
          label: "三大中心",
          icon: require("@/assets/newindex/icon1.png"),
        },
        {
          num: "9",
          label: "九大行业应用",
          icon: require("@/assets/newindex/icon2.png"),
        },
        {
          num: "30+",
          label: "技术栈覆盖",
          icon: require("@/assets/newindex/icon3.png"),
        },
        {
          num: "6年",
          label: "行业深耕",
          icon: require("@/assets/newindex/icon4.png"),
        },
      ],
      capabilities: [
        {
          title: "AI智能能力中心",
          desc: "AI智能能力中心是平台的智能内核，通过农业认知引擎构建全领域知识底座，依托RAG、知识图谱和行业大模型等技术栈，为行业应用提供病虫害识别、产量预测等可复用的模型服务和智能决策能力。",
          list: ["农业认知引擎", "核心技术栈", "模型服务与生命周期"],
          img: require("@/assets/newindex/icon5.png"),
          detailImg: require("@/assets/newindex/detail_ai.png"),
          detailCards: [
            {
              title: "农业认知引擎",
              desc: "覆盖作物、品种、病虫害、农事规范、农资商品等全领域知识体系，构建可检索、可解释、可持续更新的农业专业知识底座。\n\n支撑智能问答与决策推理，知识范围涵盖作物生长阶段、症状防治、生产规范和农资安全标准。",
            },
            {
              title: "核心技术栈",
              desc: "核心技术包括RAG检索增强、知识图谱构建、行业大模型微调、知识审核机制和版本管理体系，确保知识准确可控。\n\n支持知识的持续更新与迭代，通过审核机制保障农业领域专业内容的权威性和时效性。",
            },
            {
              title: "模型服务与生命周期",
              desc: "提供病虫害识别、产量预测、价格预测、灾害评估和农事推荐等模型服务，以API形式快速集成至业务场景。\n\n支持模型训练、管理、调用和效果评估的完整生命周期，算法结果结合业务数据、空间位置和作物阶段返回业务场景。",
            },
          ],
        },
        {
          title: "数据智能中心",
          desc: "数据智能中心覆盖数据汇聚、治理、分析和服务全链路，通过农业数字大脑、空间数字孪生和数据资产平台三大产品，为政府、企业和AI应用提供统一的数据分析与经营决策能力，实现数据驱动的精准洞察。",
          list: ["农业数字大脑", "空间数字孪生", "数据资产平台"],
          img: require("@/assets/newindex/icon6.png"),
          detailImg: require("@/assets/newindex/detail_data.png"),
          detailCards: [
            {
              title: "农业数字大脑",
              desc: "多源数据汇聚与质量监控，建立主题域、指标、口径和标签体系，覆盖生产、经营、库存、交易、客户和服务分析。\n\n提供BI看板、专题分析、经营报表和异常预警能力，面向政府、企业和平台运营者输出分层决策视图。",
            },
            {
              title: "空间数字孪生",
              desc: "GIS地图、地块边界、作物分布和种植批次关联管理，三维农场、遥感和无人机数据展示。\n\n气象、土壤、灾害和生产态势可视化，提供基于空间位置的巡田、预警、统计和热力分析能力。",
            },
            {
              title: "数据资产平台",
              desc: "管理作物、土壤、气象、生产、交易等全域数据资产，提供数据目录、标准、质量、授权和服务管理能力。\n\n向数字大脑提供标准数据，向AI中心提供训练和推理素材，向业务应用提供受控的数据服务。",
            },
          ],
        },
        {
          title: "产业运营中心",
          desc: "产业运营中心是平台的管理、运营和生态协同中枢，通过产业运营平台、企业运营平台和生态运营平台三大产品，将数据和能力转化为可执行的运营动作，实现区域治理、企业经营和生态协同的全面覆盖。",
          list: ["产业运营平台", "企业运营平台", "生态运营平台"],
          img: require("@/assets/newindex/icon7.png"),
          detailImg: require("@/assets/newindex/detail_operation.png"),
          detailCards: [
            {
              title: "产业运营平台",
              desc: "面向政府和区域管理者，支持区域农业主体、资源和产业分布管理，覆盖产业链、重点项目和园区运营。\n\n 提供项目任务、政策服务、招商协同和运营评价，输出产业态势和决策驾驶舱支撑区域农业治理。",
            },
            {
              title: "企业运营平台",
              desc: "面向农业企业和合作社，统一管理生产经营、供应链管理、客户运营和订单协同。\n\n集成库存管理、财务结算和经营分析能力，调用各应用形成企业级经营工作台。",
            },
            {
              title: "生态运营平台",
              desc: "双端模式：生态主体自助端维护资料、资质和服务目录接单，平台治理端负责审核、认证、撮合和任务分发。\n\n构建主体管理、资质认证、合作撮合、履约评价、分账结算和渠道管理能力，形成可信参与者网络。",
            },
          ],
        },
        {
          title: "产业交易服务层",
          desc: "产业交易服务层是位于三大中心与行业应用之间的横向业务能力层，不作为独立应用单独建设，而是为农资、农服、农产品等多个平台沉淀订单、履约、结算等可复用的公共交易能力，避免不同平台重复建设。",
          list: ["服务覆盖与参与者网络", "端到端交易流程", "金融级交易保障"],
          img: require("@/assets/newindex/icon8.png"),
          detailImg: require("@/assets/newindex/detail_trade.png"),
          detailCards: [
            {
              title: "服务覆盖与参与者网络",
              desc: "覆盖农资采购与销售、农业服务交易、农产品采购销售及跨产业链撮合协同四大业务域。\n\n共享交易主体、商家、供应商、采购方和资质管理能力，建立统一参与者网络。",
            },
            {
              title: "端到端交易流程",
              desc: "提供商品目录、询价报价、撮合匹配、订单合同的完整交易流程支撑。\n\n支持批次管理、履约交付、验收售后的供应链协同能力，确保交易全链路可追踪。",
            },
            {
              title: "金融级交易保障",
              desc: "沉淀结算分账、对账评价、交易风控和争议处理的金融级交易保障能力。\n\n输出信用数据，为农业经营信用平台和供应链金融提供交易行为基础。",
            },
          ],
        },
      ],
      industryActiveId: 0,
      hoverCapabilityIndex: -1,
      industryTabs: [
        {
          title: "智能体与智慧农业",
          icon: require("@/assets/newindex/tabicon1.png"),
        },
        {
          title: "供应链与农服",
          icon: require("@/assets/newindex/tabicon2.png"),
        },
        {
          title: "交易与客户增长",
          icon: require("@/assets/newindex/tabicon3.png"),
        },
        {
          title: "智慧门店系统",
          icon: require("@/assets/newindex/tabicon4.png"),
        },
        {
          title: "信用平台与物流",
          icon: require("@/assets/newindex/tabicon5.png"),
        },
      ],
      industryContents: [
        {
          title: "智能体与智慧农业",
          desc: "云小稼智能体作为平台统一AI交互入口，以多模态问答和任务代理能力连接用户与平台；云稼智慧农业作为生产过程数字化管理平台，两者分别代表平台的智能前端和生产核心，构成从智能交互到生产执行的完整链路",
          phone1: require("@/assets/newindex/app1.png"),
          type: "app",
        },
        {
          title: "供应链与农服",
          desc: "农资供应链平台连接农资商品从生产到终端的完整流通链路，农服生态平台连接农业服务的供需双方实现作业履约。两者通过产业交易服务层共享订单与结算能力，通过生态运营平台共享主体资质管理，形成农资+农服的协同生态",
          phone1: require("@/assets/newindex/app2.png"),
          phone2: require("@/assets/newindex/ind_phone2.png"),
          type: "app",
        },
        {
          title: "交易与客户增长",
          desc: `农业交易平台连接产地到渠道的农产品流通链路，客户增长平台替代孤立CRM实现持续经营。两者通过交易数据和客户行为的打通，形成从交易获客到复购运营的完整增长飞轮，驱动农业企业可持续增长`,
          phone1: require("@/assets/newindex/app3.png"),
          phone2: require("@/assets/newindex/ind_phone2.png"),
          type: "app",
        },
        {
          title: "智慧门店系统",
          desc: `云稼智慧门店通过“旺店+POS+云小稼"三端协同覆盖店主经营、前台收银和客户购买全场景，与农资供应链、客户增长和云小稼智能体深度联动，将传统农资门店升级为数字化智能零售终端`,
          phone1: require("@/assets/newindex/app4.png"),
          phone2: require("@/assets/newindex/ind_phone2.png"),
          type: "pc",
        },
        {
          title: "信用平台与物流",
          desc: "信用平台基于生产经营数据构建农业经营信用体系为供应链金融提供数据基础，物流平台连接配送资源实现履约协同。两者分别补齐产业链的金融信任和物流交付环节，与交易、生产应用形成完整闭环",
          phone1: require("@/assets/newindex/app5.png"),
          phone2: require("@/assets/newindex/ind_phone2.png"),
          type: "app",
        },
      ],
      architectureCards: [
        {
          title: "行业应用层",
          desc: "智慧农业、农资供应链、农服生态、农业交易等九大应用生态，直接承载生产、经营、服务和交易流程",
          icon: require("@/assets/newindex/arch_icon1.png"),
          bg: require("@/assets/newindex/bg1.png"),
        },
        {
          title: "产业交易服务层",
          desc: "沉淀订单、履约、结算等跨场景复用的公共交易能力，为农资、农服、农产品等多个平台提供统一交易基础设施",
          icon: require("@/assets/newindex/arch_icon2.png"),
          bg: require("@/assets/newindex/bg2.png"),
        },
        {
          title: "三大能力中心",
          desc: "AI智能能力中心提供理解与决策，数据智能中心提供汇聚与洞察，产业运营中心提供管理与协同",
          icon: require("@/assets/newindex/arch_icon3.png"),
          bg: require("@/assets/newindex/bg3.png"),
        },
        {
          title: "统一数字底座",
          desc: "提供身份认证、组织权限、业务协同、平台接入和基础数据等公共能力，所有应用共享复用",
          icon: require("@/assets/newindex/arch_icon4.png"),
          bg: require("@/assets/newindex/bg4.png"),
        },
      ],
      architectureTags: [
        {
          groups: [
            {
              title: "统一身份与租户体系",
              tags: [
                "账号管理",
                "单点认证",
                "租户隔离",
                "多组织切换",
              ],
            },
            {
              title: "组织与权限体系",
              tags: [
                "组织",
                "岗位",
                "角色",
                "菜单权限",
                "操作权限",
                "数据权限",
              ],
            },
          ],
        },
        {
          groups: [
            {
              title: "业务协同能力",
              tags: [
                "工作流引擎",
                "任务管理",
                "审批流程",
                "表单",
                "日程",
                "待办",
                "消息通知",
              ],
            },
            {
              title: "平台接入能力",
              tags: [
                "API网关",
                "开放接口",
                "回调",
                "文件服务",
                "设备接入",
                "第三方系统连接",
              ],
            },
          ],
        },
        {
          groups: [
            {
              title: "基础数据能力",
              tags: [
                "管理行政区划",
                "计量单位",
                "品类",
                "主体",
                "地块",
                "客户",
              ],
            },
            {
              title: "组织与权限体系",
              tags: [
                "数据安全",
                "租户隔离",
                "访问控制",
                "操作审计",
                "服务治理",
                "运行监控",
              ],
            },
          ],
        },
      ],
      loopCards: [
        {
          title: "生产端",
          desc: "生产计划驱动农事执行形成生产记录，产出质量与库存数据，种植过程全程数字化为后续环节提供可信数据源",
        },
        {
          title: "交易端",
          desc: "质量与库存数据支撑产地采购，进入订单交易、加工物流和销售环节，打通产销链路实现农产品价值最大化",
        },
        {
          title: "智能端",
          desc: "全链路数据汇入数据智能中心，经AI分析产生智能推荐和决策支持，算法模型持续学习优化提升预测准确度",
        },
        {
          title: "反馈端",
          desc: "智能推荐回流生产计划，优化下一轮种植决策和经营策略，形成正向循环推动产业数字化能力持续迭代升级",
        },
      ],
      processSteps: [
        { title: "接入", icon: require("@/assets/newindex/process_icon1.png") },
        { title: "沉淀", icon: require("@/assets/newindex/process_icon2.png") },
        { title: "理解", icon: require("@/assets/newindex/process_icon3.png") },
        { title: "应用", icon: require("@/assets/newindex/process_icon4.png") },
        { title: "反馈", icon: require("@/assets/newindex/process_icon5.png") },
      ],
      aboutInfo: {
        company: "武汉云稼科技有限公司",
        desc: "公司经营范围覆盖第二类增值电信业务，以及软件开发、人工智能基础软件开发、互联网数据服务、物联网应用服务、网络技术服务、大数据服务、信息系统集成、信息技术咨询、与农业生产经营有关的技术和信息服务等。公司开展AI智能体业务与其农业数字化、软件研发、互联网数据服务及信息技术服务业务方向一致",
        img: require("@/assets/newindex/about1.png"),
      },
    };
  },
  methods: {
    onConsult() {
      // 后续可接入客服弹窗或跳转咨询页面
    },
    // onCardEnter(index) {
    //   this.hoverCapabilityIndex = index;
    // },
    // onCardLeave() {
    //   this.hoverCapabilityIndex = -1;
    // },
    switchIndustry(index) {
      this.industryActiveId = index;
    },
    hoverTab(index) {
      this.industryActiveId = index;
    },
    onViewScheme() {
      // 后续接入对应解决方案跳转或客服咨询
      this.$router.push({ path: "/product" });
    },
    onViewMore() {
      this.$router.push({ name: "About" });
    },
  },
};
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 564px;
  background: url("../../assets/banner/newindex.png") no-repeat center center;
  background-size: 100% 100%;
}

.section-inner {
  width: 1196px;
  margin: 0 auto;
  box-sizing: border-box;
}

/* Hero Banner */
.hero-section {
  width: 100%;
  padding-top: 64px;
  /* 避开固定导航 64px + 40px 留白 */
  padding-bottom: 138px;
  box-sizing: border-box;

  .hero-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 100px;
  }

  .hero-left {
    flex: 1;
    max-width: 640px;
    font-size: 16px;
  }

  .hero-title {
    font-size: 44px;
    font-weight: 700;
    color: #3982f7;
    line-height: 1.25;
    margin: 0 0 20px;
    letter-spacing: 1px;
  }

  .hero-subtitle {
    font-size: 18px;
    color: #333333;
    line-height: 1.8;
    margin-top: 12px;
  }

  .hero-btn {
    width: 140px;
    height: 44px;
    font-size: 16px;
    border-radius: 4px;
    background-color: #3982f7;
    border-color: #3982f7;
    margin-top: 80px;

    &:hover {
      background-color: #5c9aff;
      border-color: #5c9aff;
    }

    i {
      margin-left: 4px;
    }
  }

  .hero-right {
    flex: 0 0 520px;
    margin-left: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hero-img {
    max-width: 100%;
    height: auto;
  }
}

/* 数据统计 */
.stats-section {
  position: relative;
  z-index: 2;
  margin-top: -56px;
  padding: 0 20px;

  .stats-inner {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }

  .stat-card {
    flex: 1;
    display: flex;
    align-items: center;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 4px 10px 0px #0000000d;
    height: 109px;
    padding: 0 24px;

    &:hover {
      transform: scale(1.03);

      transition: transform 0.2s ease;
    }
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .stat-num {
    font-size: 30px;
    font-weight: 700;
    color: #333333;
    line-height: 32px;
  }

  .stat-label {
    font-size: 14px;
    color: #666666;
    margin-top: 8px;
  }
}

/* 核心能力中心 */
.capability-section {
  width: 100%;
  background: #ffffff;
  padding: 80px 0 0 0;

  .capability-grid {
    position: relative;
    width: 100%;
    height: 534px;
  }

  .capability-card {
    position: relative;
    display: flex;
    width: 588px;
    height: 257px;
    align-items: center;
    background: #f5f8fe;
    border-radius: 8px;
    padding: 40px;
    overflow: hidden;
    transition: all 0.2s ease;

    &:nth-of-type(1) {
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
    }

    &:nth-of-type(2) {
      position: absolute;
      z-index: 1;
      right: 0;
      top: 0;
    }

    &:nth-of-type(3) {
      position: absolute;
      z-index: 1;
      left: 0;
      bottom: 0;
    }

    &:nth-of-type(4) {
      position: absolute;
      z-index: 1;
      right: 0;
      bottom: 0;
    }

    &:hover {
      position: absolute;
      z-index: 10;
      width: 1196px;
      height: 534px;
      background: #3982f7;
      padding: 32px 24px 24px 24px;
      border-radius: 12px;

      .capability-title {
        color: #ffffff;
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 16px;
      }

      .capability-list {
        display: none;
      }

      .capability-detail-desc {
        display: block;
        margin-bottom: 32px;
      }

      .capability-detail-cards {
        display: grid;
      }

      .capability-img {
        top: 0;
        right: 0;
        width: 320px;
        height: 320px;
        z-index: -1;
        margin: 0;
      }
    }
  }

  .capability-normal {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .capability-content {
    flex: 1;
  }

  .capability-title {
    font-size: 33px;
    font-weight: 500;
    color: #333333;
    margin: 0 0 25px;
  }

  .capability-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #333333;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .check-icon {
      width: 20px;
      height: 20px;
      margin-right: 7px;
    }
  }

  .capability-img {
    position: absolute;
    right: 40px;
    width: 132px;
    height: 132px;
    top: 0;
    bottom: 0;
    margin: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .capability-detail-desc {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.8;
    margin: 0;
    display: none;
    padding-right: 320px;
  }

  .capability-detail-cards {
    display: grid;
    height: 0;
    flex: 1;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    display: none;
  }

  .capability-detail-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 24px;
    transition: transform 0.3s ease;

    .detail-card-title {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      margin: 0 0 20px;
      text-align: center;
    }

    .detail-card-desc {
      font-size: 16px;
      color: #666666;
      line-height: 28px;
      margin: 0;
      white-space: pre-line;
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(12px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

/* 行业应用生态 */
.industry-section {
  width: 100%;
  // background: #f5f8fe;
  padding: 80px 0 0 0;

  .industry-tabs {
    display: flex;
    justify-content: space-around;
  }

  .industry-tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 50px;
    cursor: pointer;
    position: relative;
    transition: color 0.2s ease;
    padding-bottom: 12px;

    .tab-icon {
      width: 48px;
      height: 48px;
      margin-bottom: 12px;
      transition: transform 0.2s ease;
    }

    .tab-text {
      font-size: 16px;
      color: #333333;
      font-weight: 500;
      transition: color 0.2s ease;
    }

    /* 选中态下划线 */
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 4px;
      border-radius: 3px;
      background: #3982f7;
      transition: width 0.2s ease;
    }

    &.active {
      .tab-icon {
        transform: translateY(-2px);
      }

      .tab-text {
        color: #3982f7;
        font-weight: 500;
      }

      &::after {
        width: 64px;
      }
    }
  }

  .industry-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 80px;
  }

  .industry-phones {
    display: flex;
    align-items: center;

    .phone {
      width: 460px;
      height: 460px;
    }

    .pc-phone {
      width: 600px;
      height: 386px;
    }
  }

  .industry-desc {
    flex: 1;
    margin-left: 111px;

    .desc-title {
      font-size: 26px;
      font-weight: 500;
      color: #1f232b;
      margin: 0 0 20px;
    }

    .desc-text {
      font-size: 16px;
      color: #333333;
      line-height: 1.9;
      margin: 0 0 80px;
    }

    .desc-btn {
      width: 120px;
      height: 40px;
      font-size: 16px;
      border-radius: 6px;
      background-color: #3982f7;
      border-color: #3982f7;

      &:hover {
        background-color: #5c9aff;
        border-color: #5c9aff;
      }

      i {
        margin-left: 4px;
      }
    }
  }
}

/* 总体架构设计 */
.architecture-section {
  width: 100%;
  background: #ffffff;
  padding: 80px 0;

  .architecture-cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-bottom: 40px;
  }

  .architecture-card {
    border-radius: 12px;
    padding: 0 20px;
    padding-top: 32px;
    text-align: center;
    height: 297px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 0;

    &:hover {
      .arch-card-bg {
        transform: scale(1.14);
      }
    }
  }

  .arch-card-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
    z-index: -1;
    // transform: scale(1);
  }

  .arch-card-icon {
    width: 52px;
    height: 52px;
    margin-bottom: 24px;
  }

  .arch-card-title {
    font-size: 22px;
    font-weight: 500;
    color: #333333;
    margin: 0 0 12px;
  }

  .arch-card-desc {
    font-size: 16px;
    color: #666666;
    line-height: 1.7;
    margin: 0;
    text-align: left;
  }

  .architecture-tags {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .arch-tag-col {
    border: 1px solid #f2f2f2;
    border-radius: 12px;
    padding: 24px 20px;
  }

  .arch-tag-group {
    margin-bottom: 32px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .arch-tag-title {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    margin: 0 0 12px;
  }

  .arch-tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .arch-tag-item {
    display: inline-block;
    height: 28px;
    line-height: 26px;
    padding: 0 8px;
    background: #ffffff;
    border: 1px solid #3982f7;
    border-radius: 6px;
    font-size: 12px;
    color: #3982f7;
  }
}

/* 业务闭环与设计原则 */
.loop-section {
  width: 100%;
  background: url("../../assets/newindex/bg5.png") no-repeat center;
  background-size: 100% 100%;
  padding: 80px 0 80px;

  .loop-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 48px;
  }

  .loop-chart {
    flex: 0 0 280px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 40px;

    img {
      max-width: 100%;
      height: auto;
    }
  }

  .loop-cards {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-left: 80px;
  }

  .loop-card {
    background: rgba(255, 255, 255, 0.5);
    border-radius: 12px;
    height: 161px;
    padding: 20px;
    box-sizing: border-box;

    .loop-card-title {
      font-size: 22px;
      font-weight: 500;
      color: #3982f7;
      margin: 0 0 16px;
    }

    .loop-card-desc {
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      margin: 0;
    }
  }

  .loop-process {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    border-radius: 16px;
    height: 152px;
    padding: 0 40px;

    .process-step {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      &:not(:last-child)::after {
        content: "";
        background: url("../../assets/newindex/arrow.png") no-repeat center;
        background-size: 100% 100%;
        width: 154px;
        height: 13px;
        position: absolute;
        right: -20px;
        top: 36%;
        transform: translate(100%, -50%);
        // margin-left: 20px;
        color: #3982f7;
        font-size: 20px;
      }
    }

    .process-icon-container {
      background: #f5f8ff;
      border-radius: 50%;
      width: 68px;
      height: 68px;
      // padding: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 12px;
    }

    .process-icon {
      width: 40px;
      height: 40px;
    }

    .process-title {
      font-size: 16px;
      color: #333333;
      font-weight: 500;
      line-height: 24px;
    }
  }
}

/* 关于我们 */
.about-section {
  width: 100%;
  background: #ffffff;
  padding: 80px 0;

  .about-header {
    text-align: center;
    margin-bottom: 44px;
  }

  .about-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .about-info {
    flex: 1;
    max-width: 600px;
  }

  .about-company {
    font-size: 22px;
    font-weight: 500;
    color: #333333;
    line-height: 33px;
    margin: 0 0 24px;
  }

  .about-desc {
    font-size: 16px;
    color: #666666;
    line-height: 1.9;
    margin: 0 0 32px;
  }

  .about-btn {
    width: 120px;
    height: 40px;
    font-size: 16px;
    border-radius: 4px;
    background-color: #3982f7;
    border-color: #3982f7;

    &:hover {
      background-color: #5c9aff;
      border-color: #5c9aff;
    }

    i {
      margin-left: 4px;
    }
  }

  .about-img {
    flex: 0 0 556px;
    margin-left: 80px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 268px;
    }
  }
}
</style>
